module.exports = __webpack_public_path__ + "img/web-programming.2e41c47e.png";